import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { State } from '../models/State';

@Injectable()
export class StateService {
  constructor(private http: Http) {}

  all(): Observable<any> {
    const url =environment.api.baseUrl +  environment.api.state;
    return this.http.get(url).map(res => {
      return res.json().map(j => new State(j));
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/state.service.ts